import { api } from '@src/service/api'
import { Category } from '@src/types/strapi'
import useSWR from 'swr'

export const useCategories = () => {
  return useSWR<Category[]>(`/categories`, () => api.get('/categories?_sort=id:ASC').then(res => res.data))
}
